const GreeceFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="4" fill="#0D5EAF"/>
    <rect y="4" width="30" height="4" fill="#FFFFFF"/>
    <rect y="8" width="30" height="4" fill="#0D5EAF"/>
    <rect y="12" width="30" height="4" fill="#FFFFFF"/>
    <rect y="16" width="30" height="4" fill="#0D5EAF"/>
    <rect x="0" y="0" width="6" height="8" fill="#0D5EAF"/>
  </svg>
);

export default GreeceFlag;